const AutoRuleEditorIcon = ({ size = 24, color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke={color}
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="1.5" y="2.5" width="21" height="20" rx="3" ry="3" />

    <line x1="6" y1="7" x2="14" y2="7" />
    <line x1="6" y1="10.3" x2="10" y2="10.3" />
    <line x1="6" y1="13.7" x2="9" y2="13.7" />
    <line x1="6" y1="17" x2="16" y2="17" />
  </svg>
);

export default AutoRuleEditorIcon;
